import view from "../../views/matches";
import KTAPI, { getAllPlayers } from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router, toggleLoader } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";


import { _user, _handler, TimeAgoUpdater } from "../classes/index.classes";

var loading = false;

let states = [
    "DEAD",
    "WARM",
    "START",
    "FH",
    "HT",
    "SH",
    "OT",
    "END"    
];

let matchTypesColor = {
    "pug": "success",
    "mix": "primary",
    "scrim": "warning",
    "league": "danger",
    "tournament": "info",
    "matchmaking": "dark",
};

let pagination = {
    page: null,
    nextPage: null,
    prevPage: null,
    hasNextPage: null,
    hasPrevPage: null,
    limit: null,
    totalDocs: null,
    totalPages: null,
    loading: false
};

let skeletonMatches = /* html */`
<tr class="cursor-pointer fs-7 text-gray-800 position-relative" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 20rem, rgb(27, 27, 27) 100rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/de_dust2.jpg');background-color:#1b1b1b;">
                <td class="ps-4 rounded-start align-middle">
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="d-flex flex-column align-items-center gap-2">
                            <div class="skeleton-loader-match skeleton-loader-match-badge mt-4"></div>
                        </div>                    
                    </div>
                </td>            
                <td class="align-middle">
                    <div class="d-flex flex-column">
                        <div class="skeleton-loader-match skeleton-loader-match-long mb-2"></div>
                        <div class="skeleton-loader-match skeleton-loader-match-long"></div>
                    </div>                
                </td>
                <td class="align-middle">
                    <div class="d-flex justify-content-around align-items-center text-white fs-4 lobby-scores">
                        <div class="skeleton-loader-match skeleton-loader-match-circle"></div>
                        <span>:</span>
                        <div class="skeleton-loader-match skeleton-loader-match-circle"></div>
                    </div>
                </td>
                <td class="align-middle fs-8">
                    <div class="d-flex flex-column align-items-center">
                        <div class="d-flex align-items-center">
                            <div class="skeleton-loader-match skeleton-loader-match-med"></div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="me-2">
                                <div class="skeleton-loader-match skeleton-loader-match-flag"></div>
                            </div>
                            <div class="skeleton-loader-match skeleton-loader-match-med"></div>
                        </div>
                    </div>
                </td>
                <td class="align-middle">
                    <div class="skeleton-loader-match skeleton-loader-match-med"></div>
                </td>
                <td class="align-middle text-center">
                    <div class="skeleton-loader-match skeleton-loader-match-med"></div>
                </td>
                <td class="align-middle">
                    <div class="skeleton-loader-match skeleton-loader-match-image"></div>
                </td>
                <td class="pe-4 rounded-end align-middle">
                    <div class="skeleton-loader-match skeleton-loader-match-med"></div>
                </td>
            </tr>
`;


let players = {
    render: () => {
        return view;
    },
    after_render: async (data) => {

        //initFilters();

        let res = null;

        if (pagination.page != null)
        {
            //res = await KTAPI.getAllMatches({paged: true, page: 1, limit: pagination.limit*pagination.page});
        }

        //$(".matches-loader").addClass("h-200px");
        //await toggleLoader(".matches-loader");

        $(".matches-list-body").empty();
        $(".matches-list-body").append(skeletonMatches.repeat(7));

        toggleLoader(".matches-list-body");

        pagination.loading = true;
        
        res = await KTAPI.getAllMatches({paged: true, page: 1, limit: 25});

        //await toggleLoader(".matches-loader");
        //$(".matches-loader").removeClass("h-200px");

        if(res.message == 'error') return;

        pagination.page = res.page;
        pagination.nextPage = res.nextPage;
        pagination.prevPage = res.prevPage;
        pagination.hasNextPage = res.hasNextPage;
        pagination.hasPrevPage = res.hasPrevPage;
        pagination.limit = res.limit;
        pagination.totalDocs = res.totalDocs;
        pagination.totalPages = res.totalPages;

        $(".matches-list-body").empty();
        renderMatchesList(res);

        pagination.loading = false;
        
        //renderMatchesListTable(res);
        
                
        KTScroll.init();

        

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content',
};


function renderMatchesList(res)
{
    if(res.message == 'error') return;
    let html = [];
    let pos = 1;
    res.docs.map(pl => {
        //html.push(renderMatchItem(pl));
        html.push(renderMatchItemTable(pl));
        pos++;
    });

    //$(".matches-list").append(html);
    $(".matches-list-body").append(html);
    router.updatePageLinks();

    function renderMatchItem(data)
    {
        let t = /* html */`
        <div class="cursor-pointer d-table-row fs-7 text-gray-800 bgi-position-y-center" href="${data.ending == 0 ? `server/${data.server.server}` : `match/${data._id}`}" data-navigo matchid="${data._id}" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/${data.map}.jpg');">
            <div class="d-table-cell py-2 px-3 ps-4 rounded-start align-middle">
                <!--<span class="my-1">${data.number}</span>-->
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column align-items-center gap-2">
                        
                        <span class="badge badge-sm flex-shrink-0 align-self-center text-gray-200 mb-2 mb-sm-0 bg-${matchTypesColor[data.type]}">${data.type.toUpperCase()}</span>
                        ${data.ending == 0 ? `<span class="badge badge-sm flex-shrink-0 align-self-center text-gray-900 mb-2 mb-sm-0 bg-gray-100"><i class="fad fa-circle text-danger me-1 fs-9"></i> LIVE</span>` : ""}
                        <!--<span class="badge badge-sm badge-primary flex-shrink-0 align-self-center text-gray-200 lobby-state mb-2 mb-sm-0" data-i18n="play.${states[data.state]}"></span>-->
                    </div>                    
                </div>
            </div>            
            <div class="d-table-cell py-2 px-3 align-middle">
                <div class="d-flex flex-column">
                    <span class="lobby-scorea fs-6 fw-bolder text-nowrap">${data.teamA_name === undefined || data.teamA_name === '' ? "TEAM_A" : data.teamA_name}${data.scoreA > data.scoreB ? `<i class="fad fa-trophy-alt text-zyellow ms-2"></i>` : ""}</span>
                    <span class="lobby-scoreb fs-6 fw-bolder text-nowrap">${data.teamB_name === undefined || data.teamB_name === '' ? "TEAM_B" : data.teamB_name}${data.scoreB > data.scoreA ? `<i class="fad fa-trophy-alt text-zyellow ms-2"></i>` : ""}</span>                    
                </div>                
            </div>
            <div class="d-table-cell py-2 px-3 align-middle">
                <div class="d-flex flex-column lobby-scores">
                    <span class="lobby-scorea fs-3 fw-bolder ${data.scoreA > data.scoreB ? "text-primary" : "text-gray-700"}">${data.scoreA}</span>
                    <span class="lobby-scoreb fs-3 fw-bolder ${data.scoreB > data.scoreA ? "text-primary" : "text-gray-700"}">${data.scoreB}</span>
                </div>                
            </div>
            <div class="d-table-cell py-2 px-3 align-middle">
                <div class="d-flex flex-column align-items-center">
                    <div class="d-flex align-items-center">
                        <span class="fw-boldest">${data.server.region}</span>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="me-2"><img class="" src="assets/media/flags/${data.server.flag}.gif"></div><span class="fw-bold my-1">${data.server.flag.toUpperCase()}, ${data.server.city.toUpperCase()}</span>
                    </div>
                </div>
            </div>
            <div class="d-table-cell py-2 px-3 align-middle">                
                <span class="fw-bold my-1">${data.vs > 5 ? 5 : data.vs}v${data.vs > 5 ? 5 : data.vs}</span>
            </div>
            <div class="d-table-cell py-2 px-3 align-middle">
                <span class="fw-bold my-1 lobby-map-name">${data.map}</span>
            </div>
            <div class="d-table-cell py-2 px-3 align-middle">
                <div class="d-flex align-items-center">
                    <div class="symbol symbol-${data.ac_required ? '30' : '20'}px" data-i18n="[title]faq.${data.ac_required ? 'ac' : 'vac'}" data-toggle="tooltip">
                        <!--<span class="symbol-label bg-gray-200 bg-opacity-75">-->
                            <img class="img-fluid" src="assets/media/logos/${data.ac_required ? 'akros-logo' : 'vac-logo'}.png" alt="">
                        <!--</span>-->
                    </div>
                </div>
            </div>
            <div class="d-table-cell py-2 px-3 pe-4 rounded-end align-middle">                                         
                <span class="fw-bold my-1 timer-${data._id}" moment-timestamp="${parseInt(data.createdAt)+hostStampDif}" data-toggle="tooltip" title=""></span>
            </div>
            
        </div>
                `;
        
        t = $(t);   
        new TimeAgoUpdater(t.find(".timer-"+data._id));
        t.localize();
        t.find("[data-toggle='tooltip']").tooltip();
        t.find("[data-toggle='tooltip']").attr("title", "");
        return t;
    }

    function renderMatchItemTable(data)
    {
        let t = /* html */`
        <tr class="cursor-pointer fs-7 text-gray-800 position-relative" href="${data.ending == 0 ? `server/${data.server.server}` : `match/${data._id}`}" data-navigo matchid="${data._id}" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 20rem, rgb(27, 27, 27) 100rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/${data.map}.jpg');background-color:#1b1b1b;">
            <td class="ps-4 rounded-start align-middle">
                
                <div class="d-flex align-items-center justify-content-center">
                    <div class="d-flex flex-column align-items-center gap-2">
                        
                        <span class="badge badge-sm flex-shrink-0 align-self-center text-gray-200 mb-2 mb-sm-0 bg-${matchTypesColor[data.type]}">${data.type.toUpperCase()}</span>
                        ${data.ending == 0 ? `<span class="badge badge-sm flex-shrink-0 align-self-center text-gray-900 mb-2 mb-sm-0 bg-gray-100"><i class="fad fa-circle text-danger me-1 fs-9"></i> LIVE</span>` : ""}

                    </div>                    
                </div>
            </td>            
            <td class="align-middle">
                <div class="d-flex flex-column">
                    <span class="lobby-scorea fw-bold text-nowrap">${data.teamA_name === undefined || data.teamA_name === '' ? "TEAM_A" : data.teamA_name}${data.scoreA > data.scoreB ? `<i class="fad fa-trophy-alt text-zyellow ms-2"></i>` : ""}</span>
                    <span class="lobby-scoreb fw-bold text-nowrap">${data.teamB_name === undefined || data.teamB_name === '' ? "TEAM_B" : data.teamB_name}${data.scoreB > data.scoreA ? `<i class="fad fa-trophy-alt text-zyellow ms-2"></i>` : ""}</span>                    
                </div>                
            </td>
            <td class="align-middle">
                <!--<div class="d-flex flex-column lobby-scores">
                    <span class="lobby-scorea fs-3 fw-bolder ${data.scoreA > data.scoreB ? "text-primary" : "text-gray-700"}">${data.scoreA}</span>
                    <span class="lobby-scoreb fs-3 fw-bolder ${data.scoreB > data.scoreA ? "text-primary" : "text-gray-700"}">${data.scoreB}</span>
                </div>-->
                <div class="d-flex justify-content-around align-items-center text-white fs-4 lobby-scores">
                    <span class="lobby-scorea fs-1 fw-bolder ${data.scoreA > data.scoreB ? "text-primary" : "text-gray-700"}">${data.scoreA}</span><span class="">:</span><span class="lobby-scoreb fs-1 fw-bolder ${data.scoreB > data.scoreA ? "text-primary" : "text-gray-700"}">${data.scoreB}</span>
                </div>
            </td>
            <td class="align-middle fs-8">
                <div class="d-flex flex-column align-items-center">
                    <div class="d-flex align-items-center">
                        <span class="fw-boldest">${data.server.region}</span>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="me-2"><img class="" src="assets/media/flags/${data.server.flag}.gif"></div><span class="fw-bold my-1">${data.server.flag.toUpperCase()}, ${data.server.city.toUpperCase()}</span>
                    </div>
                </div>
            </td>
            <td class="align-middle">                
                <span class="fw-bold my-1">${data.vs > 5 ? 5 : data.vs}v${data.vs > 5 ? 5 : data.vs}</span>
            </td>
            <td class="align-middle text-center">
                <!--<span class="fw-bold my-1 lobby-map-name"></span>-->
                <span class="badge badge-sm badge-dark border border-primary flex-shrink-0 align-self-center text-primary fs-small lobby-map-name" style="background-color: rgba(27,27,27,0.8)">${data.map}</span>
            </td>
            <td class="align-middle">
                <div class="d-flex align-items-center">
                    <div class="symbol symbol-${data.ac_required ? '30' : '20'}px" data-i18n="[title]faq.${data.ac_required ? 'ac' : 'vac'}" data-toggle="tooltip">
                        <!--<span class="symbol-label bg-gray-200 bg-opacity-75">-->
                            <img class="img-fluid" src="assets/media/logos/${data.ac_required ? 'akros-logo' : 'vac-logo'}.png" alt="">
                        <!--</span>-->
                    </div>
                </div>
            </td>
            <td class="pe-4 rounded-end align-middle">                                         
                <span class="fw-bold my-1 timer-${data._id}" moment-timestamp="${parseInt(data.createdAt)+hostStampDif}" data-toggle="tooltip" title=""></span>
            </td>
            
        </tr>
                `;
        
        t = $(t);   
        new TimeAgoUpdater(t.find(".timer-"+data._id));
        t.localize();
        t.find("[data-toggle='tooltip']").tooltip();
        t.find("[data-toggle='tooltip']").attr("title", "");
        return t;
    }
}


$(document).ready(function(){        
    $(window).scroll(async function() {
        if(router.getCurrentLocation().url.includes("matches"))
        {
            if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !pagination.loading && pagination.hasNextPage) {
                pagination.loading = true;
                $(".matches-loader").addClass("h-200px");
                await toggleLoader(".matches-loader");
                
                let res = await KTAPI.getAllMatches({paged:true, page:pagination.nextPage, limit:pagination.limit});

                await toggleLoader(".matches-loader");
                $(".matches-loader").removeClass("h-200px");

                if(res.message == 'error') return;
                
                pagination.page = res.page;
                pagination.nextPage = res.nextPage;
                pagination.prevPage = res.prevPage;
                pagination.hasNextPage = res.hasNextPage;
                pagination.hasPrevPage = res.hasPrevPage;
                pagination.limit = res.limit;
                pagination.totalDocs = res.totalDocs;
                pagination.totalPages = res.totalPages;
                
                renderMatchesList(res);
                
                pagination.loading = false;
                
            }
        }
    });

});


const getEloLevel = (rate, rd) => {
    if(rd == 100) return 0;
    if(rate > 0 && rate < 801)
    {
        return 1;
    }
    if(rate > 800 && rate < 951)
    {
        return 2;
    }
    if(rate > 950 && rate < 1101)
    {
        return 3;
    }
    if(rate > 1100 && rate < 1251)
    {
        return 4;
    }
    if(rate > 1250 && rate < 1401)
    {
        return 5;
    }
    if(rate > 1400 && rate < 1551)
    {
        return 6;
    }
    if(rate > 1550 && rate < 1701)
    {
        return 7;
    }
    if(rate > 1700 && rate < 1851)
    {
        return 8;
    }
    if(rate > 1850 && rate < 2001)
    {
        return 9;
    }
    if(rate > 2000)
    {
        return 10;
    }
};



export default players;